import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'bg-primary-600 text-primary-foreground hover:bg-primary-700',
        secondary: 'bg-secondary text-secondary-foreground hover:bg-muted',
        success: 'bg-success-100 text-success-700 hover:bg-success-200',
        warning: 'bg-warning-100 text-warning-700 hover:bg-warning-200',
        error: 'bg-error-100 text-error-700 hover:bg-error-200',
        outline: 'border border-input bg-background hover:bg-accent hover:text-accent-foreground',
        primary: 'bg-primary-600 text-white hover:bg-primary-700',
        'primary-inverted': 'bg-white/20 text-white border border-white/30 hover:bg-white/30',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}
